import styles from "./WorkUpgradePage.module.scss";
import { PageTitleBlock } from "../../components/PageTitleBlock/PageTitleBlock";
import { CardWrapper } from "../../components/CardWrapper/CardWrapper";
import { UpgradeCard } from "./UpgradeCard/UpgradeCard";
import energyIcon from "./UpgradeCard/icons/energy.png";
import recoveryIcon from "./UpgradeCard/icons/recovery.png";
import profitIcon from "../../icons/currency-large.png";
import { useDispatch, useSelector } from "../../hooks";
import { upgradeWork } from "../../redux/work/upgrade-handler";
import { AppContext } from "../../components/Menu/MenuButton";
import { useNavigate } from "../../hooks/navigate";
import { BalanceErrorType, useBalanceError } from "../../hooks/error";
import { setUserExp } from "../../redux/user";

export enum WorkProp {
    Capacity = 'capacity',
    ProfitRate = 'profitRate',
    StoreSpeed = 'storeSpeed',
}

export const WorkUpgradePage = () => {
    const work = useSelector(store => store.work);
    const { balance } = useSelector(store => store.user.info);

    const balanceError = useBalanceError();
    const dispatch = useDispatch();
    const nivagate = useNavigate();

    const upgradeHandler = async (workProp: WorkProp) => {
        if (!work)
            return;
        
        const prop = () => {
            switch (workProp) {
                case WorkProp.Capacity: return work.capacity;
                case WorkProp.ProfitRate: return work.profitRate;
                case WorkProp.StoreSpeed: return work.storeSpeed;
                default:
                    return;
            }
        };

        const cost = prop()?.cost;
        if (!cost)
            return;

        if (balance < cost) {
            balanceError(cost, BalanceErrorType.WorkUpgrade);
            return;
        }

        const resultAction = await dispatch(upgradeWork(workProp));
        if (upgradeWork.fulfilled.match(resultAction)) {            
            const { exp } = resultAction.payload;
            if (exp !== undefined)
                dispatch(setUserExp(exp));
        }
    }

    return (
        <div className={styles.wrapper}>
            <PageTitleBlock pageTitle={"Улучшения"} />
            
            { work && <CardWrapper>
                { work.capacity &&  <UpgradeCard
                        description="Объем энергии"
                        unitName='ед'
                        iconType={ energyIcon }
                        workProp={ work.capacity }
                        handler={ () => upgradeHandler(WorkProp.Capacity) }
                /> }

                { work.storeSpeed && <UpgradeCard
                        description="Восстановление"
                        unitName='ед/сек'
                        iconType={ recoveryIcon }
                        workProp={ work.storeSpeed }
                        handler={ () => upgradeHandler(WorkProp.StoreSpeed) }
                /> }

                { work.profitRate && <UpgradeCard
                        description="Доход от энергии"
                        unitName='ед'
                        iconType={ profitIcon }
                        workProp={ work.profitRate }
                        handler={ () => upgradeHandler(WorkProp.ProfitRate) }
                /> }
            </CardWrapper> }

            <button
                className={styles.closeButton}
                onClick={ () => nivagate(AppContext.Office) }
            >
                Закрыть
            </button>
        </div>
    );
};